import { render } from "./TraitementConsultation.vue?vue&type=template&id=3400cf31&scoped=true"
import script from "./TraitementConsultation.vue?vue&type=script&lang=js"
export * from "./TraitementConsultation.vue?vue&type=script&lang=js"

import "./TraitementConsultation.vue?vue&type=style&index=0&id=3400cf31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3400cf31"]])

export default __exports__